import '@/assets/style/global.less';
import { useBrand, useRuntimeInfo } from '@/hooks';
import { setReferrerURL } from '@/utils/session';
import { lazyWithPreload } from '@zenlayer/portal-utils';
import { Suspense } from 'react';

const Entry = lazyWithPreload(() => import('@/entry'));
const App = () => {
  useBrand();
  setReferrerURL();

  const { ready } = useRuntimeInfo();

  return <Suspense>{ready && <Entry />}</Suspense>;
};

export default App;
